import React from 'react';
import Svg from '../Svg';

const IconArrowCircleUpLeft = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM8.00019 9.00005C8.00019 8.44777 8.4479 8.00005 9.00019 8.00005H15.0002C15.5525 8.00005 16.0002 8.44777 16.0002 9.00005C16.0002 9.55234 15.5525 10.0001 15.0002 10.0001H11.4144L15.7073 14.2928C16.0978 14.6833 16.0978 15.3165 15.7073 15.707C15.3168 16.0976 14.6836 16.0976 14.2931 15.7071L10.0002 11.4142V15.0001C10.0002 15.5523 9.55247 16.0001 9.00019 16.0001C8.4479 16.0001 8.00019 15.5523 8.00019 15.0001V9.00005Z"
    />
  </Svg>
);

export default IconArrowCircleUpLeft;
